var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-scrollable",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h4",
                { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
                [_vm._v(_vm._s(_vm.$t("common.contacts.editModal.title")))]
              )
            ]),
            _vm._v(" "),
            _vm.contact
              ? _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("ul", { staticClass: "nav nav-tabs mb-3" }, [
                      _c("li", { staticClass: "nav-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link",
                            class: { active: _vm.activeTab === "main" },
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.activeTab = "main"
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.contact.main"))
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.details
                        ? _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "nav-link",
                                class: { active: _vm.activeTab === "details" },
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.activeTab = "details"
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("common.contact.details"))
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("li", { staticClass: "nav-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link",
                            class: { active: _vm.activeTab === "media" },
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.activeTab = "media"
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.contact.tabs.picture"))
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("TabMain", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "main",
                          expression: "activeTab === 'main'"
                        }
                      ],
                      attrs: {
                        availableSalutations: _vm.availableSalutations,
                        contact: _vm.contact
                      }
                    }),
                    _vm._v(" "),
                    _vm.details
                      ? _c("TabDetails", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeTab === "details",
                              expression: "activeTab === 'details'"
                            }
                          ],
                          attrs: { contact: _vm.contact }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("TabPicture", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "media",
                          expression: "activeTab === 'media'"
                        }
                      ],
                      attrs: { contact: _vm.contact }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", disabled: !_vm.canSave },
                  on: {
                    click: function($event) {
                      return _vm.$emit("save", _vm.contact)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("btnSave")) + "\n        "
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }